import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('FriendsPressedButton').create(({ theme }) => ({
  joinCommunityButton: {
    width: '50%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    fontWeight: 460,
    fontSize: '13px',
    textAlign: 'center',
    padding: '0px 8px',
    gap: '4px',
    position: 'relative',
    overflow: 'hidden',
    lineHeight: theme.sizes.texts.lineHeight.s,
  },

  keysContainer: {
    position: 'absolute',
    right: '4px',
    borderRadius: theme.sizes.radiuses.m,
    top: '4px',
    display: 'flex',
    background: '#3247a1',
    padding: '0px 6px',
    width: 'fit',
    height: '24px',
    alignItems: 'center',

    span: {
      fontSize: '15px',
      fontWeight: 490,
      lineHeight: '21px',
      color: theme.colors.text.primary,
    },
  },
}))
